import * as React from 'react';
import { SwitchWidget, SwitchWidgetProps } from './SwitchWidget';
import { styled } from '../../theme';

export interface SwitchLabelWidgetProps extends SwitchWidgetProps {
  label: string | React.JSX.Element;
  className?: any;
}

export const SwitchLabelWidget: React.FC<SwitchLabelWidgetProps> = (props) => {
  return (
    <S.Container className={props.className}>
      <S.Label>{props.label}</S.Label>
      <S.StyledSwitch checked={props.checked} onChange={props.onChange} disabled={props.disabled} />
    </S.Container>
  );
};

namespace S {
  export const Container = styled.div`
    display: flex;
    flex-direction: row;
    color: ${(p) => p.theme.text.primary};
    padding: 8px;
  `;

  export const Label = styled.div`
    font-size: 14px;
    cursor: pointer;
    user-select: none;
    flex-grow: 1;
    padding-left: 8px;
  `;

  export const StyledSwitch = styled(SwitchWidget)`
    margin-top: 2px;
    width: 16px;
    height: 16px;
  `;
}
